import { Box, Stepper, Typography } from 'enova-frontend-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { camelCasify, RegistrationCommonStep } from '../../../utils/navigation';
import useRegistrationForm from '../useRegistrationForm';
import { StepperId } from '../utils';

export const RegistrationStepper = () => {
  const { t } = useTranslation();
  const { step, steps, goToStep, registrationId } = useRegistrationForm();

  const getStepperTOptions = () => {
    const stepIndex = steps.indexOf(step);

    return {
      stepCount: steps.length,
      stepName: steps[stepIndex] ? t(`register.step.${camelCasify(steps[stepIndex])}`) : '',
      stepNo: stepIndex + 1
    };
  };

  return (
    <Box id={StepperId}>
      <Typography variant="srOnly">{t('stepper', getStepperTOptions())}</Typography>
      <Stepper aria-hidden>
        {steps.map((registrationStep, index) => {
          const currentStepIndex = steps.indexOf(step);
          //   Disable step navigation:
          //   - If no registration has been created
          //   - To energy certificate step to force submission of registration from summary step
          //   - If current step is not before the step in question
          const isNavigationAvailable =
            !!registrationId &&
            registrationStep !== RegistrationCommonStep.ENERGY_CERTIFICATE &&
            currentStepIndex > index;

          const navigateToStep = isNavigationAvailable ? () => goToStep(registrationStep) : undefined;

          return (
            <Stepper.Step
              active={registrationStep === step}
              done={index < currentStepIndex || step === RegistrationCommonStep.ENERGY_CERTIFICATE}
              onClick={navigateToStep}
              key={registrationStep}
              label={`${index + 1}. ${t(`register.step.${camelCasify(registrationStep)}`)}`}
            />
          );
        })}
      </Stepper>
    </Box>
  );
};
